import { DashboardScreen } from '@/features/dashboard/components/dashboard-screen';

export function DashboardPage() {
  return <DashboardScreen />;
}
